'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGpt = require('react-gpt');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# GoogleAd
A basic GoogleAd.
*/

var GoogleAd = function GoogleAd(_ref) {
  var adUnitPath = _ref.adUnitPath,
      height = _ref.height,
      width = _ref.width,
      userClassTarget = _ref.userClassTarget,
      siteNameTarget = _ref.siteNameTarget,
      siteAreaTarget = _ref.siteAreaTarget,
      pageNameTarget = _ref.pageNameTarget;
  return _react2.default.createElement(_reactGpt.Bling, {
    adUnitPath: adUnitPath,
    slotSize: [width, height],
    targeting: {
      UserClass: userClassTarget,
      SiteName: siteNameTarget,
      SiteArea: siteAreaTarget,
      PageName: pageNameTarget
    }
  });
};

GoogleAd.propTypes = {
  /** ad unit path */
  adUnitPath: _propTypes2.default.string.isRequired,
  /** advertisement slot height */
  height: _propTypes2.default.number.isRequired,
  /** advertisement slot width */
  width: _propTypes2.default.number.isRequired,
  /** user class used for targeting */
  userClassTarget: _propTypes2.default.string.isRequired,
  /** site name used for targeting */
  siteNameTarget: _propTypes2.default.string.isRequired,
  /** site area used for targeting */
  siteAreaTarget: _propTypes2.default.string.isRequired,
  /** page name used for targeting */
  pageNameTarget: _propTypes2.default.string.isRequired
};

GoogleAd.displayName = 'GoogleAd';

exports.default = GoogleAd;
GoogleAd.__docgenInfo = {
  'description': '# GoogleAd\r\nA basic GoogleAd.',
  'methods': [],
  'displayName': 'GoogleAd',
  'props': {
    'adUnitPath': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'ad unit path'
    },
    'height': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'advertisement slot height'
    },
    'width': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'advertisement slot width'
    },
    'userClassTarget': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'user class used for targeting'
    },
    'siteNameTarget': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'site name used for targeting'
    },
    'siteAreaTarget': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'site area used for targeting'
    },
    'pageNameTarget': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'page name used for targeting'
    }
  }
};